const questionsModels = [
  {
    label: 'What was your sex assigned at birth?',
    field: 'wlusFollowup_genderIdentify',
    extras: { sendToBeluga: false },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlusFollowup_genderIdentify_male',
          value: 'Male'
        },
        {
          key: 'wlusFollowup_genderIdentify_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    field: 'wlusFollowup_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    field: 'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlusFollowup_PregnantOrBreastfeedingOrPlanningTo_yes',
          value: 'Yes'
        },
        {
          key: 'wlusFollowup_PregnantOrBreastfeedingOrPlanningTo_no',
          value: 'No'
        }
      ]
    }
  },

  {
    field: 'wlusFollowup_consentPregnancy',
    label: 'Consent (pregnancy),',
    type: 'select',
    educationalSlide:
      'Read the following for more information about this product and its potential side effects:\n It is not safe to take these medications while pregnant or breastfeeding. The FDA advises that these medications may pose a risk to a developing fetus. Oral contraceptives alone may not be effective, as the medication can reduce their effectiveness. The FDA specifically recommends continuing oral contraception alongside a barrier method (like condoms) for the first month after starting a weight loss medication and for the first month after any dose increase. Alternatively, you can switch to a non-oral contraceptive method (such as an IUD or implant) before beginning the medication. After stopping the medication, you should continue using a backup method, such as condoms, for two months to ensure the medication has fully cleared your system before trying to conceive. Additionally, its safety during breastfeeding is unknown, so if you are nursing, consult your doctor to explore safer weight loss options.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I DO NOT wish to continue',
          class: 'option-decline',
          key: 'wlusFollowup_consentPregnancy_non_consent'
        },
        {
          value:
            'I acknowledge that I have read and understood the above information',
          class: 'option-consent',
          key: 'wlusFollowup_consentPregnancy_consent'
        }
      ]
    }
  },
  {
    // TODO if BMI is under 27 for a treatment naive patient → disqualified; if BMI is under 23 for a patient currently on treatment → disqualified
    label: 'What is your:',
    field: 'wlusFollowup_weightAndHeight2025',
    type: 'info',
    required: false,
    answer: {
      type: 'bmi',
      showLabel: true,
      bmiLabel: 'Your BMI is',
      heightLabel: 'What is your height in feet and inches?',
      weightLabel: 'What is your weight in pounds?'
    }
  },
  {
    // TODO if BMI is under 27 for a treatment naive patient → disqualified; if BMI is under 23 for a patient currently on treatment → disqualified
    label: 'What is your:',
    field: 'wlusFollowup_weightAndHeight',
    type: 'info',
    required: false,
    answer: {
      type: 'bmi',
      showLabel: true,
      bmiLabel: 'BMI',
      heightLabel: 'Height',
      weightLabel: 'Weight'
    }
  },

  {
    field: 'wlusFollowup_consentBmi',
    label: 'Consent (BMI):',
    type: 'select',
    educationalSlide:
      'The traditional use of weight loss medications is for individuals with a BMI of 30 and above or to those who are overweight who have associated health conditions. Using it for someone with a BMI range (27-29) without an accompanying health condition is termed "off-label." Using a medication "off-label" refers to the practice of prescribing a drug for a purpose, age group, dosage, or form of administration that is not included in the approved labeling by regulatory agencies like the U.S. Food and Drug Administration (FDA). While a medication undergoes rigorous testing for specific uses before receiving approval, healthcare providers may discover through clinical experience or research that it can be effective for treating other conditions. There may be benefits such as weight reduction for individuals within your range. If you agree to this off-label use, it\'s crucial to follow the prescribed regimen and report any concerns. Please discuss any questions with us.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue',
          class: 'option-decline',
          key: 'wlusFollowup_consentBmi_non_consent'
        },
        {
          class: 'option-consent',
          key: 'wlusFollowup_consentBmi_consent',
          value:
            'I acknowledge that I have read and understood the above information'
        }
      ]
    }
  },

  {
    label:
      'Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in?',
    field:
      'wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn_yes',
          value: 'Yes'
        },
        {
          key: 'wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn_no',
          value: 'No'
        }
      ]
    }
  },

  {
    label: 'Please tell us more about the changes in your health',
    field: 'wlusFollowup_tellUsMoreAboutTheChangesInYourHealth',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlusFollowup_tellUsMoreAboutTheChangesInYourHealth'
    }
  },

  {
    label: 'Please identify all your current medical conditions',
    field: 'wlusFollowup_identifyAllYourCurrentMedicalConditions',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlusFollowup_identifyAllYourCurrentMedicalConditions_desc'
    }
  },

  {
    label: 'Please list all your current medications including dosages',
    field: 'wlusFollowup_listAllYourCurrentMedicationsIncludingDosages',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlusFollowup_listAllYourCurrentMedicationsIncludingDosages_desc'
    }
  },

  {
    label: 'Please list all of your known allergies',
    field: 'wlusFollowup_listAllOfYourKnownAllergies',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlusFollowup_listAllOfYourKnownAllergies_desc'
    }
  },

  {
    label: 'Have you had a gastric bypass in the past 6 months?',
    field: 'wlusFollowup_hadAGastricBypassInThePast6Months',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlusFollowup_hadAGastricBypassInThePast6Months_yes',
          value: 'Yes'
        },
        {
          key: 'wlusFollowup_hadAGastricBypassInThePast6Months_no',
          value: 'No'
        }
      ]
    }
  },

  {
    label: 'When did you last take your prescribed weight loss medication?',
    field: 'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication_withinThePastWeek',
          value: 'Within the past week'
        },
        {
          key: 'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication_withinThePastTwoWeeks',
          value: 'Within the past two weeks'
        },
        {
          key: 'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication_withinThePastMonth',
          value: 'Within the past month'
        },
        {
          key: 'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication_itHasBeenOverAMonth',
          value: 'It has been over a month'
        },
        {
          key: 'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication_itHasBeenOver_2Months',
          value: 'It has been over 2 months'
        }
      ]
    }
  },

  {
    label: 'Have you experienced side effects from your current medication?',
    field:
      'wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication_yes',
          value: 'Yes'
        },
        {
          key: 'wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication_no',
          value: 'No'
        }
      ]
    }
  },

  {
    label: "Please describe the side effects that you've experienced",
    field: 'wlusFollowup_describeTheSideEffectsThatYouVeExperienced',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlusFollowup_describeTheSideEffectsThatYouVeExperienced'
    }
  },

  {
    label:
      'Which medication and dose most closely matches your most recent dose?',
    field:
      'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose',
    type: 'select',
    educationalSlide: `
      Keep in mind:
      
              Tirzepatide = Mounjaro, Zepbound
              Semaglutide = Ozempic, Wegovy
      
    `,
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_semaglutide0-25mg',
          value: 'Semaglutide 0.25mg'
        },
        {
          key: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_semaglutide0-5mg',
          value: 'Semaglutide 0.5mg'
        },
        {
          key: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_semaglutide1mg',
          value: 'Semaglutide 1mg'
        },
        {
          key: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_semaglutide1-7mg',
          value: 'Semaglutide 1.7mg'
        },
        {
          key: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_semaglutide2-4mg',
          value: 'Semaglutide 2.4mg'
        },
        {
          key: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide2-5mg',
          value: 'Tirzepatide 2.5mg'
        },
        {
          key: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide5mg',
          value: 'Tirzepatide 5mg'
        },
        {
          key: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide7-5mg',
          value: 'Tirzepatide 7.5mg'
        },
        {
          key: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide10mg',
          value: 'Tirzepatide 10mg'
        },
        {
          key: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide12-5mg',
          value: 'Tirzepatide 12.5mg'
        },
        {
          key: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide15mg',
          value: 'Tirzepatide 15mg'
        }
      ]
    }
  },
  {
    label: 'Are you experiencing a reduction in food cravings with this dose? ',
    field:
      'wlusFollowup_areYouExperiencingAReductionInFoodCravingsWithThisDose',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlusFollowup_areYouExperiencingAReductionInFoodCravingsWithThisDose_yesThisIsHelping',
          value: 'Yes, this is helping'
        },
        {
          key: 'wlusFollowup_areYouExperiencingAReductionInFoodCravingsWithThisDose_yesButINeedMoreHelp',
          value: 'Yes but I need more help'
        },
        {
          key: 'wlusFollowup_areYouExperiencingAReductionInFoodCravingsWithThisDose_noINoticedNoDifferenceYet',
          value: 'No I haven’t noticed a difference yet'
        }
      ]
    }
  },
  {
    label: 'How would you like to continue your treatment?',
    field: 'wlusFollowup_howWouldYouLikeToContinueYourTreatment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlusFollowup_howWouldYouLikeToContinueYourTreatment_stayAtTheSameDoseOrEquivalentDose',
          value: 'Stay at the same dose or equivalent dose'
        },
        {
          key: 'wlusFollowup_howWouldYouLikeToContinueYourTreatment_increaseTheDoseIfAHigherOneIsAvailableOrContinueWithMyCurrentDoseIfItSAlreadyAtTheMaximum',
          value:
            "Increase the dose if a higher one is available, or continue with my current dose if it's already at the maximum"
        },
        {
          key: 'wlusFollowup_howWouldYouLikeToContinueYourTreatment_decreaseDose',
          value: 'Decrease dose'
        }
      ]
    }
  },

  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'wlusFollowup_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlusFollowup_otherInformationOrQuestionsDoYouHaveForTheDoctor'
    }
  },

  {
    field: 'wlusFollowup_consentTruthfulness',
    label: 'Consent (Truthfulness): ',
    type: 'select',
    educationalSlide: `Please attest to the following confirming that all information you have provided to us is true and complete.
    Consent: I verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me.  I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor.  I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to move forward',
          class: 'option-decline',
          key: 'wlusFollowup_consentTruthfulness_non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'wlusFollowup_consentTruthfulness_consent'
        }
      ]
    }
  },

  {
    field: 'wlusFollowup_consentGLP1GIP',
    label: 'Consent (GLP-1 and GLP-1/GIP):',
    type: 'select',
    educationalSlide: `
    Indication for Use
    You are requesting treatment with a GLP-1 (Ozempic, Wegovy, or compounded semaglutide) or GIP/GLP-1 receptor agonist (Mounjaro, Zepbound, or compounded tirzepatide) medication as part of your treatment plan for the management of weight or obesity. These medications work by mimicking the action of incretin hormones, which help regulate blood sugar levels, promote feeling full, and reduce food intake.

    Potential Benefits:
        Weight loss or weight management
        Improved blood glucose control
        Reduced cardiovascular risk
        Potential improvement in overall metabolic health

    Potential Side Effects:
    While these medications can be beneficial, they may also cause side effects. Although not common, these medications can result in emergency room visits, hospitalizations, or even death. Common and serious side effects include, but are not limited to:
    
    Common Side Effects:
    
        Nausea
        Vomiting
        Diarrhea
        Constipation
        Decreased appetite
        Indigestion
    

    Serious Side Effects:
    
        Pancreatitis (inflammation of the pancreas)
        Hypoglycemia (low blood sugar), especially when used with other diabetes medications
        Gallbladder disease (e.g., gallstones)
        Kidney problems
        Allergic reactions (e.g., rash, itching, swelling)
        Gastroparesis (paralysis of the bowels)
    

    Risks and Considerations:
    
        Pancreatitis: There is a risk of developing pancreatitis. If you experience severe abdominal pain, nausea, or vomiting, you should contact your healthcare provider immediately.
        Thyroid Tumors: Animal studies have shown an increased risk of thyroid tumors with certain GLP-1 medications. Although this has not been confirmed in humans, please inform your healthcare provider if you have a history of thyroid cancer.
        Hypoglycemia: When taken with other diabetes medications, particularly insulin or sulfonylureas, there is a risk of low blood sugar. It is important that your provider knows if any of these medications are added to your regimen.
        Kidney Function: This medication may affect kidney function, particularly in patients with existing kidney disease. Regular monitoring of kidney function may be required.
    

    Monitoring and Follow-up:
    You will require regular follow-up visits to monitor your response to the medication and to assess for any side effects. We may intermittently ask for full-body selfie images to ensure that your reported weight is consistent.

    I acknowledge the potential benefits, risks, and side effects of GLP-1 or GIP/GLP-1 receptor agonist medications. I understand the importance of regular monitoring and follow-up appointments. I consent to the use of GLP-1 or GIP/GLP-1 receptor agonist medications as part of my treatment plan for overweight or obesity.
    `,
    answer: {
      type: 'single_select',
      options: [
        {
          class: 'option-decline',
          key: 'wlusFollowup_consentGLP1GIP_non_consent',
          value:
            'I have read the above information and I do NOT wish to continue'
        },
        {
          class: 'option-consent',
          key: 'wlusFollowup_consentGLP1GIP_consent',
          value:
            'I have read and understand the above information and I wish to continue'
        }
      ]
    }
  },

  {
    label:
      'Have you experienced any of the following side effects from your current medication? (Select all that apply)',
    field: 'wlusFollowup_sideEffects',
    type: 'select',
    extras: { sendToBeluga: false },
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'fatigue',
          value:
            'Yes I have experienced fatigue and WOULD like to explore the option of including an additive which may help manage my fatigue symptoms'
        },
        {
          key: 'nausea',
          value:
            'Yes I have experienced nausea and WOULD like to explore the option of including an additive which may help reduce your nausea'
        },
        {
          key: 'muscleloss',
          value:
            'Yes I have experienced muscle loss and WOULD like to explore the option of including an additive which may help to support muscle health'
        },
        {
          key: 'noSideEffects',
          uncheckOthers: true,
          value: 'No'
        }
      ]
    }
  },
  {
    class: 'ineligible',
    field: 'wlusFollowup_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    educationalSlide: '',
    extras: { sendToBeluga: false },
    reject: true,
    type: 'info',
    isLast: true,
    answer: {}
  },
  {
    field: 'wlusFollowup_ineligibleChangeMedication',
    label: 'Change Medication',

    subLabel:
      'You have selected the option to change medication, please contact our support team to change your medication to a different one',
    educationalSlide:
      'If you would like to stay with this medication, you can go back and select a different option',
    extras: { sendToBeluga: false },
    reject: true,
    type: 'info',
    isLast: true,
    answer: {}
  },
  {
    field: 'wlusFollowup_ineligibleCantFindLastFulfill',
    label: 'Previous Prescription',
    subLabel: 'We were not able to find your previous prescription',
    educationalSlide: 'Please contact support about this issue',
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    type: 'info',
    isLast: true,
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'wlusFollowup_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    educationalSlide: '',
    extras: { sendToBeluga: false },
    reject: true,
    type: 'info',
    isLast: true,
    answer: {}
  },
  {
    label: 'How are you doing on your medication?',
    field: 'wlusFollowup_medicationExperience',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          // Route to Rapid Titration Regimen
          key: 'rapidTitration',
          value:
            "I'm NOT losing weight (1-2 pounds/week) and I AM NOT having side effects"
        },
        {
          // Decided in next question
          key: 'sharedDecision',
          value:
            "I'm NOT losing weight (1-2 pounds/week) and I AM having side effects"
        },
        {
          // Route to Split Dosing
          key: 'splitDosing',
          value:
            "I'm losing weight (1-2 pounds/week) but I AM having side effects"
        },
        {
          // Route to Alternative Titration Regimen
          key: 'alternativeTitration',
          value:
            "I'm losing weight (1-2 pounds/week) and I AM NOT having side effects"
        }
      ]
    }
  },
  {
    label:
      'Shared decision making is extremely important to ensure that this works into your lifestyle.  Would you like to mitigate these side effects by',
    field: 'wlusFollowup_sharedDecisionMaking',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          // Route to split dosing regimen
          key: 'splitDosing',
          value:
            'I would like to inject a smaller dose twice a week instead of a larger dose once weekly to mitigate these symptoms'
        },
        {
          // Route to standard Titration regimen
          key: 'standardTitration',
          value: 'No, I would like to stick with the standard dosing'
        }
      ]
    }
  },
  {
    field: 'wlusFollowup_consentPregnancy2025',
    label: 'Consent (pregnancy),',
    type: 'select',
    educationalSlide: `Read the following for more information about this product and its potential side effects:\n It is not safe to take these medications while pregnant or breastfeeding. The FDA advises that these medications may pose a risk to a developing fetus. Oral contraceptives alone may not be effective, as the medication could reduce their effectiveness. The FDA specifically recommends continuing oral contraception alongside a barrier method (like condoms) for the first month after starting a weight loss medication and for the first month after any dose increase. Alternatively, you can switch to a non-oral contraceptive method (such as an IUD or implant) before beginning the medication. After stopping the medication, you should continue using a backup method, such as condoms, for two months to ensure the medication has fully cleared your system before trying to conceive. Additionally, its safety during breastfeeding is unknown, so if you are nursing, consult your doctor to explore safer weight loss options.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: `I acknowledge that I have read and understood the above information`,
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    label:
      'Have there been any health changes, medication changes, ED visits, surgeries, or hospitalizations since your last check-in?',
    field: 'wlusFollowup_healthChangesMedicationChanges2025',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Which medication and dose most closely matches your most recent dose?',
    field: 'wlusFollowup_identifyClosestDose',
    type: 'select',
    educationalSlide: `
      Keep in mind:
      
              Tirzepatide = Mounjaro, Zepbound
              Semaglutide = Ozempic, Wegovy

    `,
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'semaglutide_0.2mg',
          value: 'Semaglutide 0.2mg'
        },
        {
          key: 'semaglutide_0.4mg',
          value: 'Semaglutide 0.4mg'
        },
        {
          key: 'semaglutide_0.6mg',
          value: 'Semaglutide 0.6mg'
        },
        {
          key: 'semaglutide_0.9mg',
          value: 'Semaglutide 0.9mg'
        },
        {
          key: 'semaglutide_1.12mg',
          value: 'Semaglutide 1.12mg'
        },
        {
          key: 'semaglutide_1.5mg',
          value: 'Semaglutide 1.5mg'
        },
        {
          key: 'semaglutide_1.9mg',
          value: 'Semaglutide 1.9mg'
        },
        {
          key: 'semaglutide_2.12mg',
          value: 'Semaglutide 2.12mg'
        },
        {
          key: 'semaglutide_2.3mg',
          value: 'Semaglutide 2.3mg'
        },
        {
          key: 'tirzepatide_1.5mg',
          value: 'Tirzepatide 1.5mg'
        },
        {
          key: 'tirzepatide_3mg',
          value: 'Tirzepatide 3mg'
        },
        {
          key: 'tirzepatide_6mg',
          value: 'Tirzepatide 6mg'
        },
        {
          key: 'tirzepatide_9mg',
          value: 'Tirzepatide 9mg'
        },
        {
          key: 'tirzepatide_11mg',
          value: 'Tirzepatide 11mg'
        },
        {
          key: 'tirzepatide_13.5mg',
          value: 'Tirzepatide 13.5mg'
        }
      ]
    }
  },
  {
    label: 'When did you last take your prescribed weight loss medication?',
    field: 'wlusFollowup_LastConsumedTimeline',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pastWeek',
          value: 'Within the past week'
        },
        {
          key: 'pastTwoWeeks',
          value: 'Within the past two weeks'
        },
        {
          key: 'pastMonth',
          value: 'Within the past month'
        },
        {
          key: 'overMonth',
          value: 'It has been over a month'
        },
        {
          key: 'pastTwoMonths',
          value: 'It has been over 2 months'
        }
      ]
    }
  },
  {
    label:
      'Please provide the approximate date (month and day) of your last use of this medication',
    field: 'wlusFollowup_dateOfLastUse',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlusFollowup_dateOfLastUse'
    }
  },
  {
    label: 'wlusFollowup_testingFlows',
    field: 'wlusFollowup_testingFlows',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'Previously Alternative',
          value: 'alternative'
        },
        {
          key: 'Previously Biweekly',
          value: 'biweekly'
        },
        {
          key: 'Previously Rapid',
          value: 'rapid'
        }
      ]
    }
  },
  {
    label: 'How are you doing on your medication?',
    field: 'wlusFollowup_medicationExperience2025',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'no_weightloss_no_sideEffects',
          value:
            'I’m not feeling the effects of this medication and I’m NOT losing weight (1-2 pounds/week) and I AM NOT having side effects'
        },
        {
          key: 'no_weightloss_yes_sideEffects',
          value:
            'I’m not feeling the effects of this medication and I’m NOT losing weight (1-2 pounds/week) but I AM having side effects'
        },
        {
          key: 'yes_weightloss_yes_sideEffects',
          value:
            'I’m feeling the effects of this medication and I’m losing weight (1-2 pounds/week) but I AM having side effects'
        },
        {
          key: 'yes_weightloss_no_sideEffects',
          value:
            'I’m feeling the effects of this medication and I’m losing weight (1-2 pounds/week) and I AM NOT having side effects'
        }
      ]
    }
  },
  /////////////////////////////
  //////// ALTERNATIVE ////////
  /////////////////////////////
  {
    label:
      '1a. We want to work together to find the right dose for you. If you’re not yet at the highest dose, would you like to move up to the next level, or try our Rapid Titration Protocol to reach your target dose a bit faster?',
    field: 'wlusFollowup_alternative_offerRapid',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'increaseAlternative',
          value:
            'I would like to increase to the next dose if I’m not already on the max dose'
        },
        {
          key: 'moveToRapid',
          value:
            'I would like to transition to the Rapid Titration Protocol if I’m not already on the max dose'
        }
      ]
    }
  },
  {
    label:
      '1b. Shared decision making is extremely important to ensure that this medication works into your lifestyle.  Would you like to try to mitigate these side effects by taking a smaller dose twice a week instead of a larger dose once a week?',
    field: 'wlusFollowup_alternative_offerBiweekly',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'moveToBiweekly',
          value:
            'I would like to take a smaller dose twice a week instead of a larger dose once a week to mitigate these symptoms'
        },
        {
          key: 'stickToAlternative',
          value:
            'No, I would like to stick with taking this medication at my current frequency'
        }
      ]
    }
  },
  /////////////////////////////
  /////////// RAPID ///////////
  /////////////////////////////
  {
    label:
      '1a. Would you like to try to mitigate these side effects by slowing down the titration and taking a smaller dose twice a week instead of a larger dose once a week?',
    field: 'wlusFollowup_rapid_offerBiweekly',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'moveToBiweekly',
          value:
            'I would like to take a smaller dose twice a week instead of a larger dose once a week to mitigate these symptoms'
        },
        {
          key: 'stickToRapid',
          value:
            'No, I would like to stick with taking this medication at my current frequency'
        }
      ]
    }
  },
  //////////////////////////////
  ////////// BIWEEKLY //////////
  //////////////////////////////
  {
    label:
      '1a. We want to work together to find the right dose for you. If you’re not yet at the highest dose, would you like to move up to the next level, or try our Rapid Titration Protocol to reach your target dose more quickly?',
    field: 'wlusFollowup_biweekly_offerAlternative',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'increaseDose',
          value:
            'I would like to increase to the next dose and stay on my twice weekly protocol '
        },
        {
          key: 'moveToAlternative',
          value:
            'I would like to transition to the Alternative Titration Protocol where I take the medication once a week'
        }
      ]
    }
  },
  ////////////////////////////
  ////////  REGULAR  /////////
  ////////////////////////////
  {
    label: 'Are you experiencing a reduction in food cravings with this dose?',
    field: 'wlusFollowup_reducationInCravings2025',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'reducedCraving',
          value: 'Yes, this is helping with my cravings'
        },
        {
          key: 'needHelp',
          value: 'Yes but I need more help'
        },
        {
          key: 'noDifference',
          value: 'No I haven’t noticed a difference yet'
        }
      ]
    }
  },
  {
    label: 'How would you like to continue your treatment?',
    field: 'wlusFollowup_continueTreatment2025',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'maintain',
          value: `Stay at the same dose or equivalent dose`
        },
        {
          key: 'increase',
          value: `Increase the dose if a higher one is available, or continue with my current dose if it's already at the maximum`
        },
        {
          key: 'decrease',
          value: `Decrease dose`
        },
        {
          key: 'changeMedication',
          value: `I would like to change to a different medication`
        }
      ]
    }
  },
  {
    label: 'Consent (Compounded):',
    educationalSlide: `
    For patients who may benefit from a more specialized approach, we offer compounded formulations of semaglutide and tirzepatide. These compounded medications can be customized with alternative dosing schedules, alternative dosing frequencies, different routes of administration, and/or additives intended to help reduce side effects commonly seen with the brand name products. 

    Compounded medications are custom-prepared by licensed pharmacists to better meet an individual patient’s specific needs. Unlike FDA-approved brand name products, compounded medications are not subject to the same rigorous testing and extensive clinical trials. This means that while they offer the advantage of customization, there may be differences in the consistency, efficacy, and safety profiles compared to those of the branded products.

    By proceeding with this treatment plan, you acknowledge that:
    - You understand that compounded medications are tailored to meet individual needs but are not subjected to the same level of testing as brand name products.
    - Your treatment plan will be determined based on your candidacy and specific health requirements, ensuring the most appropriate therapy for you.

    Please review this information carefully. If you have any questions or need further clarification regarding your treatment options, do not hesitate to ask our healthcare team. Your health and well-being are our highest priorities, and we are here to support you in making the best-informed decision about your care.
`,
    field: 'wlusFollowup_consentCompounded',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          class: 'option-decline',
          key: 'nonConsent',
          value:
            'I have read the above information and I do NOT wish to continue'
        },
        {
          class: 'option-consent',
          key: 'consent',
          value:
            'I have read and understand the above information and I do consent and wish to move forward with this treatment plan'
        }
      ]
    }
  }
] as const;

export default questionsModels;

